"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCustomerPosition = void 0;
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const GeoLocation_1 = require("./GeoLocation");
let OrderCustomerPosition = class OrderCustomerPosition {
    userId;
    location;
};
exports.OrderCustomerPosition = OrderCustomerPosition;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], OrderCustomerPosition.prototype, "userId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => GeoLocation_1.GeoLocation),
    __metadata("design:type", GeoLocation_1.GeoLocation)
], OrderCustomerPosition.prototype, "location", void 0);
exports.OrderCustomerPosition = OrderCustomerPosition = __decorate([
    (0, type_graphql_1.ObjectType)("OrderCustomerPosition")
], OrderCustomerPosition);
//# sourceMappingURL=OrderCustomerPosition.js.map